import BaseClient from './BaseClient';

/**
 * DO NOT REFACTOR TO ContextClient until the context client handles canceling requests.
 */
class GroupContactsClient extends BaseClient {
    groupContactsList(teamId, groupId, params, config) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/search/contacts`;

        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    groupContactGet(teamId, groupId, contactId, config = {}) {
        const method = 'get';
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/contacts/${contactId}`;

        return this.makeCoreApiRequest(url, method, undefined, undefined, config);
    }

    groupContactSave(teamId, groupId, data, config) {
        const method = 'post';
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/contacts`;

        return this.makeCoreApiRequest(url, method, data, null, config);
    }

    groupContactUpdate(teamId, groupId, contactId, $contact) {
        const method = 'put';
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/contacts/${contactId}`;

        return this.makeCoreApiRequest(url, method, $contact);
    }

    groupContactTagsList(teamId, groupId, contactId, config = {}) {
        const method = 'get';
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/contacts/${contactId}/tags`;
        const params = {
            per_page: 100,
        };

        return this.makeCoreApiRequest(url, method, null, params, config);
    }

    groupContactAddTag(teamId, groupId, contactId, $tag) {
        const method = 'post';
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/contacts/${contactId}/tags`;

        return this.makeCoreApiRequest(url, method, $tag);
    }

    groupContactDelete(teamId, groupId, contactId) {
        const method = 'delete';
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/contacts/${contactId}`;

        return this.makeCoreApiRequest(url, method);
    }

    groupContactDeleteTag(teamId, groupId, contactId, $tagName) {
        const method = 'delete';
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/contacts/${contactId}/tags/${encodeURIComponent(
            $tagName
        )}`;

        return this.makeCoreApiRequest(url, method);
    }

    groupContactCustomAttributesList(teamId, groupId, contactId, config = {}) {
        const method = 'get';
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/contacts/${contactId}/custom-attributes`;
        const params = {
            per_page: 100,
        };

        return this.makeCoreApiRequest(url, method, null, params, config);
    }

    groupContactCustomAttributesUpsert(teamId, groupId, contactId, data = {}) {
        const method = 'post';
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/contacts/${contactId}/custom-attributes`;

        return this.makeCoreApiRequest(url, method, data);
    }

    groupContactCustomAttributesDelete(teamId, groupId, contactId, customAttributeId) {
        const method = 'delete';
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/contacts/${contactId}/custom-attributes/${customAttributeId}`;

        return this.makeCoreApiRequest(url, method);
    }

    groupContactSubscriptionStatus(teamId, groupId, contactId, config = {}) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/contacts/${contactId}/subscriptions`;

        return this.makeCoreApiRequest(url, 'get', undefined, undefined, config);
    }
}

export default new GroupContactsClient();
